export const getAppBasePath = () => {
  return (window.CONFIG.basename || '').replace(/\/$/, '');
};

export const getAppBaseUrl = () => {
  const baseName = getAppBasePath();
  return `${window.location.origin}${baseName}`;
};

export const getSearchApiDomain = (): string => {
  return window.CONFIG.coreAPIDomain || '';
};

export const getFeedbackApiDomain = (): string => {
  return window.CONFIG.feedbackDomain || '';
};

export const getSvDomain = (): string => {
  return window.CONFIG.svDomain || '';
};
